import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";


export default () => {//this component shows start and end time ,discount time and charged time
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    return (
        <div className=" d-flex moving_charges">
            <div className="row moving_charges_row">
                <div className="col start_end_col">
                    <HoursType record={IV1_PageDetails.StartEndTime}/>
                    <StartEndTime heading={"START TIME"} record={IV1_PageDetails.StartEndTime} type={"Start"}/>
                    <StartEndTime heading={"END TIME"} record={IV1_PageDetails.StartEndTime} type={"End"}/>
                    <HourlyRate heading={"HOURS RATE"} record={IV1_PageDetails.StartEndTime}/>
                </div>
            </div>
            <div className="col moving_charges_col">
                     <p className="charge_text">MEAL TIME ALLOWANCE OR TIME LOST DUE TO WEATHER CONDITIONS</p>
            </div>
            {IV1_PageDetails.DigitalInvoicePagePricingData ?
                <>
            <div className="col moving_charges_col">
                <DiscountOrChargedTime chargeType={"DISCOUNT TIME"} value={IV1_PageDetails.DigitalInvoicePagePricingData.Discount} />
            </div>
            <div className="col">
                <DiscountOrChargedTime chargeType={"TOTAL CHARGED TIME"} value={IV1_PageDetails.DigitalInvoicePagePricingData.TotalChargeTime} />
            </div>
                </> : ""}
        </div>
    )
}

const HoursType = (props) => {
    return (
        <div className="col">
            <p className="charge_text"><b>HOURS TYPE</b></p>
            {props.record.map((time,key)=>{
                return(
                    <input type="text" className="form-control input_field" key={key + 'startTime1'}
                           placeholder={time.HoursType} disabled />
                )
            })}
        </div>
    )
}

const HourlyRate = (props) => {
    const { record, heading } = props;

    // Make sure record is an array
    if (!Array.isArray(record)) {
        if (typeof window !== 'undefined' && window.__DEBUG) {
            console.debug('HourlyRate: record is not an array', record);
        }
        return null;
    }

    // Simple function to get type
    const getType = (t) => {
        const type = t.HoursType != null ? t.HoursType :
            t.HourType != null ? t.HourType : '';
        return type.trim();
    };

    return (
        <div className="col">
            <p className="charge_text"><b>{heading || 'HOURS RATE'}</b></p>

            {record.map((time, key) => {
                const hoursType = getType(time);
                const isPacking = /^packing$/i.test(hoursType);
                const rateValue = time.HourlyRate != null ? time.HourlyRate : '';

                if (typeof window !== 'undefined' && window.__DEBUG) {
                    console.debug(`HourlyRate row ${key}: type='${hoursType}' rate='${rateValue}' packing=${isPacking}`);
                }

                // When type = packing → show hidden disabled input
                if (isPacking) {
                    return (
                        <input
                            type="text"
                            className="form-control input_field"
                            key={key + 'hourlyRatePacking'}
                            value=""
                            disabled
                            style={{ visibility: 'hidden' }}
                        />
                    );
                }

                // Normal rate input
                return (
                    <input
                        type="text"
                        className="form-control input_field"
                        key={key + 'hourlyRate'}
                        value={rateValue}
                        disabled
                    />
                );
            })}
        </div>
    );
};

const StartEndTime = (props) =>{
    return(
        <>
            <div className="col">
                <p className="charge_text"><b>{props.heading}</b></p>
                {props.record.map((time,key)=>{
                    return(
                        props.type === "Start" ?
                        <input type="text" className="form-control input_field" key={key + 'startTime1'}
                               placeholder={time.StartTime} disabled />
                            :
                            <input type="text" className="form-control input_field" key={key + 'endTime1'}
                                   placeholder={time.EndTime} disabled />
                    )

                })}
            </div>
        </>
    )
}

const DiscountOrChargedTime = (props) =>{
    return(
        <>
            <p  className="charge_text"><b>{props.chargeType}</b></p>
            <input type="text" className="form-control input_field_2"
                   placeholder={props.value} disabled />
        </>
    )

}